import { MeteringPointMeasurements } from "models/electricity/metering-point";
import moment from "moment";
import React from "react";
import { Spinner } from "react-bootstrap";

interface ElectricityConsumptionSummaryProps {
    measurementData?: MeteringPointMeasurements;
    loading: boolean;
}

export default function ElectricityConsumptionSummary({ measurementData, loading }: ElectricityConsumptionSummaryProps) {

    const lastYearConsumptionForPeriodKwh = measurementData?.statistics?.lastYearConsumptionForPeriodKwh;
    const lastYearProductionForPeriodKwh = measurementData?.statistics?.lastYearProductionForPeriodKwh;

    const periodConsumptionDiff = (measurementData?.statistics?.consumptionForPeriodKwh ?? 0) - (lastYearConsumptionForPeriodKwh ?? 0);
    const periodProductionDiff = (measurementData?.statistics?.productionForPeriodKwh ?? 0) - (lastYearProductionForPeriodKwh ?? 0);

    let periodConsumptionPercentage = 0;
    if (lastYearConsumptionForPeriodKwh) {
        periodConsumptionPercentage = periodConsumptionDiff / lastYearConsumptionForPeriodKwh * 100;
    }

    let periodProductionPercentage = 0;
    if (lastYearConsumptionForPeriodKwh) {
        periodProductionPercentage = periodProductionDiff / lastYearConsumptionForPeriodKwh * 100;
    }

    const lastYearBeforePeriod = measurementData?.startDate ? moment(measurementData.startDate).add('year', -1).format('YYYY') : '';

    return (
    <div className="row">
        <div className={`col-12 col-md-6 mt-4 mt-md-0`}>
            <div className="d-flex flex-column align-items-start text-white bg-primary rounded p-3 h-100">
                <div className="u-fs-14">Valitud perioodi tarbimine</div>
                { !loading ? <>
                    <div className="u-fs-18 text-dark font-weight-bold bg-secondary-light rounded px-3 py-2 my-2">
                        { measurementData?.statistics?.consumptionForPeriodKwh }&nbsp;kWh
                    </div>       
                    { lastYearConsumptionForPeriodKwh ? <div className="d-block w-100">      
                        <div className="row u-fs-14">
                            <div className="col-12 col-xl-7">
                                { lastYearBeforePeriod } aasta tarbimine valitud perioodil
                            </div>
                            <div className="col-12 col-xl-5 d-flex">
                                <strong>{ lastYearConsumptionForPeriodKwh }&nbsp;kWh</strong>
                                <strong className="ml-2 ml-xl-auto">{ periodConsumptionPercentage.toFixed(2) }%</strong>
                                { periodConsumptionPercentage ? <i className={periodConsumptionPercentage > 0 ? "icon__tailed-arrow-up" : "icon__tailed-arrow-down"}></i> : null }
                            </div>
                        </div>
                    </div> : null }
                </> : <Spinner animation="grow" className="mx-auto my-5" /> }
            </div>
        </div>
        { measurementData?.statistics?.productionForPeriodKwh ? <div className="col-12 col-md-6">
            <div className="d-flex flex-column align-items-start bg-white rounded p-3 h-100">
                <div className="u-fs-14">Valitud perioodi tootmine</div>
                { !loading ? <>
                    <div className="u-fs-18 text-dark font-weight-bold bg-secondary-light rounded px-3 py-2 my-2">
                        { measurementData?.statistics?.productionForPeriodKwh }&nbsp;kWh
                    </div>
                    { lastYearProductionForPeriodKwh ? <div className="d-block w-100">      
                        <div className="row u-fs-14">
                            <div className="col-12 col-xl-7">
                                { lastYearBeforePeriod } aasta tootmine valitud perioodil
                            </div>
                            <div className="col-12 col-xl-5 d-flex">
                                <strong>{ lastYearProductionForPeriodKwh }&nbsp;kWh</strong>
                                <strong className="ml-2 ml-xl-auto">{ periodProductionPercentage.toFixed(2) }%</strong>
                                { periodProductionPercentage ? <i className={periodProductionPercentage > 0 ? "icon__tailed-arrow-up bg-dark" : "icon__tailed-arrow-down bg-dark"}></i> : null }
                            </div>
                        </div>
                    </div> : null }
                </> : <Spinner animation="grow" className="mx-auto my-auto" />}
            </div>
        </div> : null }        
    </div>
    );
}